import { render, staticRenderFns } from "./good-stuff.vue?vue&type=template&id=2ef4bdf7&scoped=true"
import script from "./good-stuff.vue?vue&type=script&lang=js"
export * from "./good-stuff.vue?vue&type=script&lang=js"
import style0 from "./good-stuff.vue?vue&type=style&index=0&id=2ef4bdf7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4bdf7",
  null
  
)

export default component.exports